import { IAddonsRequest } from '../../interfaces/addons.interface'

export class GetAddonsSummary {
  static readonly type = '[Addons] Get Addons Summary'
  constructor(public payload: IAddonsRequest) {}
}
